/* src/app/component/custom-dialog/custom-dialog.component.scss */
.btn-1 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
}
.subdomain-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  width: 150px;
  margin-left: 5px;
}
.btn-warning-1 {
  background-color: white;
  color: #344054;
  border: 1px solid #344054;
}
.btn-seconary-warning {
  background-color: #ff8c00;
  color: white;
  border: 1px solid #ff8c00;
}
.btn-warning-1:hover {
  background-color: #f5f5f5;
}
.btn-seconary-warning:hover {
  background-color: #e67e00;
}
.dialog-container {
  background-color: white;
  border-radius: 8px;
  width: 100%;
}
.dialog-header {
  margin-bottom: 16px;
}
.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  line-height: 28px;
}
.dialog-body {
  margin-bottom: 24px;
}
.dialog-message {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #344054;
  margin-bottom: 12px;
  margin-top: 0px;
}
.dialog-details {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dialog-detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.dialog-icon {
  font-size: 10px;
  color: #344054;
  margin-right: 8px;
}
.dialog-detail-text {
  font-size: 14px;
  color: #344054;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.btn {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  height: 40px;
}
.btn-cancel {
  background-color: white;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-approve {
  color: black;
}
.approveContent span {
  font-size: 18px;
  color: #101828;
}
.messagecontent {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #344054;
}
.btn-1:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.file-upload-container {
  border: 1px dashed #E4E7EC;
  border-radius: 6px;
  padding: 20px;
  margin-top: 24px;
  background-color: #F9FAFB;
}
/*# sourceMappingURL=custom-dialog.component-TJCERHPK.css.map */
